import { ItemList } from '../orm'

class BibNumberRecognitionList extends ItemList {

  getEntityKey() {
    return 'photographer/bib_number_recognition'
  }

  indexGallery(galleryId) {
    return this.saveNewObject({
      action: 'index_gallery',
      gallery_id: galleryId
    })
  }
}

export const bibNumberRecognitionList = new BibNumberRecognitionList('bib_number_recognition__default');
